export const nameOrDefault = (value, defaultValue, convertToUpper = false) => {
    const result = value && value.length > 0 ? value : defaultValue;
    return convertToUpper ? result.toUpperCase() : result;
}
